<template>
  <div>
    <v-dialog
      v-model="show"
      max-width="500"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card dark>
          <v-toolbar flat>
          <v-toolbar-title>
            {{ mode }} this query
            <sup>
              <font
                size="2"
                color="#f7184d"
                style="margin-top: 50px;"
              >
                New
              </font>
            </sup>
          </v-toolbar-title>
          </v-toolbar>
          <v-container fluid>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs6
              >
                <v-text-field
                  v-model="name"
                  label="Name"
                  placeholder="Enter this query's name" />
              </v-flex>

              <v-spacer />

              <v-flex
                xs5
              >
                <v-select
                  v-model="category"
                  :items="categoryOptions"
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="_id"
                  label="Category(*)"
                  placeholder="Choose one" />
              </v-flex>

              <v-flex
                xs12
              >
                <v-text-field
                  v-model="command"
                  :rules="[rules.required]"
                  label="Command(*)"
                  placeholder="Input your search query" />
              </v-flex>

              <v-flex
                xs12
              >
                <v-text-field
                  v-model="description"
                  label="Description"
                  placeholder="Create an understandable description here..." />
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red"
              style="outline: none; text-transform: none;"
              outline
              @click="show = false,clickCancle()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              style="outline: none; text-transform: none;"
              @click="submit"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="submitted"
      max-width="290"
    >
      <v-card dark>
        <v-toolbar flat>
          <v-toolbar-title>
            Save Complete
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          {{ submitResponse }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            flat
            style="outline: none;"
            @click="submitted = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from 'axios'
import jwtDecode from 'jwt-decode'
export default {
  name: 'DialogSave',

  props: {
    value: {
      type: Boolean,
      default: false
    },

    mode: {
      type: String,
      default: 'Save'
    },

    savedSearches: {
      type: Array,
      default: () => ([
        {
          _id: '',
          name: '',
          savedCommands: [
            {
              _id: '',
              name: '',
              description: '',
              command: ''
            }
          ]
        }
      ])
    },

    text: {
      type: String,
      default: ''
    },

    editingCommand: {
      type: Object,
      default: () => ({
        _id: '',
        name: '',
        command: '',
        description: '',
        categoryId: ''
      })
    }
  },

  data () {
    return {
      valid: false,
      submitted: false,
      submitResponse: '',
      name: '',
      category: '',
      command: '',
      description: '',
      rules: {
        required: v => !!v || 'Required'
      },
      ampid: '',
      token: ''
    }
  },

  created () {
    this.token = sessionStorage.getItem('user-token')
    let decoded = jwtDecode(this.token)
    this.ampid = decoded.ampid
  },

  computed: {
    show: {
      get () {
        return this.value
      },
      set (show) {
        this.$emit('input', show)
      }
    },

    categoryOptions: {
      get () {
        const categories = this.savedSearches.map(savedCategory => {
          return {
            _id: savedCategory._id,
            name: savedCategory.name
          }
        })
        return categories.filter(category => category.name !== 'Custom')
      }
    }
  },

  watch: {
    value (value) {
      if (this.mode === 'Save') {
        this.command = this.text
      }
      this.name = ''
      this.category = ''
      this.description = ''
    },

    text (text) {
      this.command = text
    },

    editingCommand (command) {
      this.name = command.name
      this.category = command.categoryId
      this.command = command.command
      this.description = command.description
    }
  },

  methods: {
    async submit () {
      window.analytics.track(`[Search][Click][Tab][Save][Submit]`, {
        value: {
          name: this.name || 'Untitled',
          description: this.description || 'No description',
          command: this.command
        }
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      if (this.$refs.form.validate()) {
        const categoryId = this.category
        const commandId = this.editingCommand._id
        const oldCategoryId = this.editingCommand.categoryId

        const response = this.mode === 'Save'
          ? await Axios.post(`${apiUrl}/api/dashboard/saved-searches/${
            categoryId}`, {
              name: this.name || 'Untitled',
              description: this.description || 'No description',
              command: this.command
            }).catch(error => alert(error))
          : await Axios.put(`${apiUrl}/api/dashboard/saved-searches/${
            categoryId}/${commandId}`, {
              name: this.name,
              description: this.description,
              command: this.command,
              oldCategoryId
            }).catch(error => alert(error))

        this.submitResponse = response.data.message
        this.$emit('get-saved-searches')
        this.show = false
        this.submitted = true
      }
    },
    clickCancle () {
      window.analytics.track(`[Search][Click][Tab][Save][Cancel]`, {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SaveQuery.vue